import React, { useEffect, useRef, useState } from 'react';
import { getChatSessionDetails } from '../../utils/api/chatApi';
import { UserRound, Bot } from 'lucide-react';

export function ChatSessionAnalysis({ sessionId, setAnalysisModal }) {
  const [isLoading, setIsLoading] = useState(false);
  const [session, setSession] = useState(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    getChatSessionDetails(sessionId)
      .then((data) => {
        if (!cancelled) setSession(data?.session || null);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [session, isLoading]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      minHeight: 0
    }}>
      {/* Header - WhatsApp style */}
      <div className="chat-sidebar-single active" style={{
        padding: '12px 16px',
        backgroundColor: '#f0f2f5',
        borderBottom: '1px solid #e9edef',
        flexShrink: 0
      }}>
        <div className="img">
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: '#25D366',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            fontWeight: '600'
          }}>
            <Bot size={20} />
          </div>
        </div>
        <div className="info">
          <h6 className="text-md mb-0">Chat Session</h6>
          <p className="mb-0" style={{ fontSize: '13px', color: '#667781' }}>ID: {sessionId}</p>
        </div>
        {setAnalysisModal && (
          <div className="action">
            <button
              onClick={() => setAnalysisModal(false)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#54656f',
                padding: '4px 8px',
                borderRadius: '6px',
                transition: 'all 0.2s ease',
                
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#e9edef';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
              }}
              title="Close"
            >
              ×
            </button>
          </div>
        )}
      </div>

      {/* Messages - WhatsApp style */}
      <div className="chat-message-list" style={{
        flex: '1 1 auto',
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: '20px',
        backgroundColor: '#efeae2',
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cdefs%3E%3Cpattern id=\'grid\' width=\'100\' height=\'100\' patternUnits=\'userSpaceOnUse\'%3E%3Cpath d=\'M 100 0 L 0 0 0 100\' fill=\'none\' stroke=\'%23e5ddd5\' stroke-width=\'1\'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width=\'100\' height=\'100\' fill=\'url(%23grid)\'/%3E%3C/svg%3E")',

        maxHeight: '100%'
      }}>
          {isLoading ? (
            <div className="d-flex flex-column" style={{ gap: '4px' }}>
              {Array.from({ length: 5 }).map((_, i) => {
                const isUser = i % 2 === 1;
                return (
                  <div key={i} className={`chat-single-message ${isUser ? 'right' : 'left'}`}>
                    {!isUser && (
                      <div className="shimmer" style={{ 
                        width: '32px', 
                        height: '32px', 
                        borderRadius: '50%' 
                      }} />
                    )}
                    <div className="chat-message-content">
                      <div 
                        className="shimmer"
                        style={{ 
                          width: '200px',
                          height: '40px',
                          borderRadius: isUser ? '7.5px 7.5px 0 7.5px' : '7.5px 7.5px 7.5px 0',
                          backgroundColor: '#e9edef',
                          marginLeft: isUser ? 'auto' : 0,
                          marginRight: isUser ? 0 : 'auto'
                        }} 
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : Array.isArray(session?.messages) && session.messages.length > 0 ? (
            <>
              {session.messages.map((m, idx) => {
                const role = (m?.role || '').toLowerCase();
                const isUser = role === 'user';

                return (
                  <div key={idx} className={`chat-single-message ${isUser ? 'right' : 'left'}`}>
                    {!isUser && (
                      <img
                        src="assets/images/favicon.png"
                        alt="avatar"
                        className="avatar-lg object-fit-cover rounded-circle"
                        style={{
                          width: '32px',
                          height: '32px'
                        }}
                      />
                      
                    )}
                    <div className="chat-message-content">
                      <p className="mb-3" style={{


                      }}>
                        {m?.content || ''}
                      </p>
                      
                    </div>
                  </div>
                );
              })}
              <div ref={messagesEndRef} />
            </>
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ 
              height: '100%', 
              textAlign: 'center',
              padding: '40px'
            }}>
              <h6 style={{ color: '#667781', marginBottom: '8px', fontSize: '16px' }}>No Messages</h6>
              <p style={{ color: '#667781', fontSize: '14px', opacity: 0.7, margin: 0 }}>
                This session doesn't have any messages yet.
              </p>
            </div>
          )}
      </div>
    </div>
  );
}
